import { PropsWithChildren } from 'react';

import { SuccessPaymentModal } from '@/features/success-payment-modal';
import { DashboardWrongModalContent } from '@/features/wrong-modal';

import { ArrowLeft } from '@/shared/assets';
import { DashboardDialogProps, Heading, Typography } from '@/shared/ui';

import { SendMoneySteps } from '../../../model/types';
import { SendMoneyStore } from '../../../model/useSendMoney';
import { ReviewDetails } from '../send-money-shared/ui/review-details';
import { SendMoneyAmount } from '../send-money-shared/ui/send-money-amount';

interface SendMoneyInnerProps extends PropsWithChildren, SendMoneyStore {
  onDone?: VoidFunction;
  onBack: () => void;
  isFirst?: boolean;
}

export const getSendMoneyInnerProps = ({
  onDone,
  step,
  setStep,
  amount,
  data,
  resetData,
  onBack,
  isFirst,
}: SendMoneyInnerProps) => {
  const handleClose = () => {
    if (step === 'amount') {
      resetData();
    }
    if (step === 'success' || step === 'error') {
      setStep('info');
      resetData();
      onDone?.();
    }
  };

  const sendMoneyInnerFlow: Record<SendMoneySteps, DashboardDialogProps> = {
    info: { content: <></> },
    bank: { content: <></> },
    address: { content: <></> },
    amount: {
      title: 'send money',
      content: <SendMoneyAmount />,
      animationProps: {
        id: 'send-money-business-amount',
      },
      height: 'fixed',
      serviceButton: {
        icon: <ArrowLeft className="!h-6 !w-6" />,
        onClick: () => {
          onBack();
        },
      },
      hideCloseButton: true,
    },
    success: {
      hideCloseButton: true,
      content: (
        <SuccessPaymentModal
          id={data?.id || ''}
          onDone={handleClose}
          hasSwitch={!!data?.id}
          mainContent={
            <div className="flex flex-col gap-4 text-center">
              <Heading variant="l">
                - {data?.account?.symbol} {data?.totalAmount}
              </Heading>
              <Typography variant="16-r">
                <p>Money is on its way to</p>
                <p>{data?.companyName}</p>
              </Typography>
            </div>
          }
        />
      ),
      animationProps: {
        id: 'success',
      },
    },
    'review-details': {
      title: 'review details',
      content: <ReviewDetails />,
      animationProps: {
        id: 'review-details',
      },
      height: 'fixed',
      hideCloseButton: true,
      serviceButton: {
        icon: <ArrowLeft className="!h-6 !w-6" />,
        onClick: () => {
          setStep('amount');
        },
      },
    },
    error: {
      headerProps: { className: 'min-h-[60px]' },
      content: <DashboardWrongModalContent onClose={() => null} />,
      serviceButton: {
        icon: <ArrowLeft className="!h-6 !w-6" />,
        onClick: () => {
          setStep('amount');
        },
      },
      animationProps: {
        id: 'error',
      },
    },
  };

  return sendMoneyInnerFlow[step];
};
